import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/student-enrollments', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-enrollments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .post('/api/student-enrollments/update-classes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/student-enrollments/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const forwardClass = data => {
  return httpClient
    .post('/api/student-enrollments/forward-classes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const fecthYear = (Option = {}) => {
  return httpClient
    .get('/api/student-enrollments/get-years', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  store,
  update,
  destroy,
  forwardClass,
  fecthYear
}
